
import axios from '../../functions/axios';
import { useState, useReducer } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import  style from'./Driver.module.css';
function EditDriver() {
  const location = useLocation();
  const navigate = useNavigate();

  const formReducer = (state, event) => {
    if (event.reset) {
      return {
        name: '',
        phoneNumber: '',
      };
    }
    return {
      ...state,
      [event.name]: event.value,
      name: location.state.driver?.name,
    };
  };

  const [formData, setFormData] = useReducer(formReducer, {
    _id: location.state.driver._id,
    name: location.state.driver.name,
    phoneNumber: location.state.driver.phoneNumber,
  });

  const handleSubmit = async (event) => {
    if (event.target.id !== 'submit') return;
    event.preventDefault();
    event.stopPropagation();
    await axios.patch(`/driver`, formData);
    navigate('/driversList');
  };

  const handleChange = (event) => {
    setFormData({
      name: event.target.name,
      value: event.target.value,
    });
  };

  const handleDeleteDriver = async (event) => {
    if (event.target.id !== 'remove') return;
    event.preventDefault();
    event.stopPropagation();
    const confirmBox = window.confirm("Czy chcesz usunąć te dane ?");
    if (confirmBox) {
      await axios.delete(`/driver`, {
        data: {
          name: location.state.driver.name,
        }
      });
    }
    navigate('/driversList');
  };

  return (
    <div className={style.wrapper}>
      <form>
        <div className={style.section}>
          <h2 className={style.category}>Edytuj dane Kierowcy </h2>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='name-data'>
              Imię i nazwisko:
            </label>
            <input type="text" id='name-data' placeholder="podaj  imię i nazwisko kierowcy" name='name' onChange={handleChange} value={location.state.driver.name} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='phoneNumber-data'>
              Nr telefonu:
            </label>
            <input type="text" id='phoneNumber-data' placeholder="podaj nr telefonu" name='phoneNumber' onChange={handleChange} value={formData.phoneNumber ?? location.state.driver.phoneNumber ?? ''} />
          </div>
      <hr />
      <span className={style.buttons}>
        <button id="cancel" className='btn btn-default' onClick={navigate.bind(null, '/driversList', { state: { date: formData.day }})}>Anuluj</button>
        <button id="remove" className='btn btn-danger' onClick={handleDeleteDriver}>Usuń</button>
        <button id="submit" className='btn btn-default' onClick={handleSubmit} type='submit'>Zapisz</button>
      </span>
    </div></form>
    </div>
  );
}

export default EditDriver;